import { createIsomorphicFn } from '@tanstack/react-start'
import { getRequestHeaders } from '@tanstack/react-start/server'

import { auth } from './auth'
import { authClient } from './auth-client'

export const getUserSessionIsomorphic = createIsomorphicFn()
  .server(async () => {
    const headers = await getRequestHeaders()
    const session = await auth.api.getSession({ headers })
    return session
  })
  .client(async () => {
    const { data } = await authClient.getSession()
    return data ?? null
  })
